export default function Space({ h = 0, w = 0 }: { h?: number; w?: number }) {
  return <div style={{ height: h, width: w }} />;
}
